(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["col-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('col-quick-add')) {
      class ColQuickAdd extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick);
        }
        onClick = (e) => {
          const t = e.target instanceof Element ? e.target : null;
          if (!t) return;
          const openBtn = t.closest('[data-col-qa-open]');
          const closeBtn = t.closest('[data-col-qa-close]');
          const addBtn = t.closest('[data-col-qa-add]');
          if (!openBtn && !closeBtn && !addBtn) return;
          e.preventDefault();
          e.stopPropagation();
          if (openBtn) {
            if (this.dataset.single) return this.add(this.dataset.single, openBtn);
            const panel = this.querySelector('[data-col-qa-panel]');
            if (panel) { panel.hidden = false; this.classList.add('is-open'); }
            return;
          }
          if (closeBtn) return this.close();
          if (addBtn instanceof HTMLButtonElement && !addBtn.disabled) this.add(addBtn.dataset.colQaAdd, addBtn);
        };
        close() {
          const panel = this.querySelector('[data-col-qa-panel]');
          if (panel) panel.hidden = true;
          this.classList.remove('is-open');
        }
        flash(text) {
          const msg = this.querySelector('[data-col-qa-msg]');
          if (!msg) return;
          msg.textContent = text;
          setTimeout(() => { msg.textContent = ''; }, 2500);
        }
        async add(id, trigger) {
          if (!id) return;
          trigger?.setAttribute('aria-busy', 'true');
          // Ask for the cart drawer markup in the same request, so the drawer refreshes before it opens
          // (a later refetch would re-render it closed)
          const sections = [...new Set([...document.querySelectorAll('[data-developly-cart-section-id]')]
            .filter((el) => el.dataset.developlySkip !== 'true')
            .map((el) => el.dataset.developlyCartSectionId)
            .filter(Boolean))];
          try {
            const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname + window.location.search }),
            });
            const data = await res.json();
            if (!res.ok) { this.flash(data.description || data.message || 'Could not add'); return; }
            const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
            this.close();
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'col-quick-add', data: { source: 'col-quick-add', itemCount: cart.item_count, variantId: String(id), sections: data.sections } } }));
          } catch (err) {
            this.flash('Could not add');
          } finally {
            trigger?.removeAttribute('aria-busy');
          }
        }
      }
      customElements.define('col-quick-add', ColQuickAdd);
    }
  } catch(e) { console.error(e); }
})();

})();
